import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@unite-us/app-components';
import { formatUpdatedAt } from '../utils/formatUpdatedAt';

export function InteractionCardHeader({ title, updatedAt }) {
  return (
    <div className="flex items-start gap-2 pb-4">
      <Icon
        className="mt-0.5 shrink-0"
        color="text-blue"
        icon="SocialEnrichment"
        size={20}
      />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <h3 className="m-0 text-base font-bold text-text-blue">
            {title}
          </h3>
          <span className="text-sm italic text-dark-grey">
            Last updated {formatUpdatedAt(updatedAt)}
          </span>
        </div>
      </div>
    </div>
  );
}

InteractionCardHeader.propTypes = {
  title: PropTypes.string,
  updatedAt: PropTypes.string,
};

InteractionCardHeader.defaultProps = {
  title: '',
  updatedAt: undefined,
};
